import { Outlet } from 'react-router-dom';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import {
  AppBar,
  Container,
  Box,
  CssBaseline,
  Toolbar,
  useMediaQuery,
  Grid,
  ImageListItem,
  ImageListItemBar, Divider
} from '@mui/material';

// project imports
import Breadcrumbs from 'ui-component/extended/Breadcrumbs';
import Header from './Header';
import navigation from 'menu-items';
// assets
import { IconChevronRight } from '@tabler/icons';
import { SnackbarProvider } from "notistack"
import {homeData} from "../../utils/constant/homeConstant";

const HomeLayout = () => {
  const theme = useTheme();

  return (
    <Box sx={{
      // display: 'flex',
      // justifyContent: 'space-between',
      // flexDirection: 'column',
      // gap: 2,
      width: '100vw',
      minHeight: '100vh',
      background: '#ffffff'
    }}>
      <CssBaseline />
      {/* header */}
      <Box position="fixed" theme={theme} sx={{ width: '100%', float:'left', background: '#ffffff'}}>
        <AppBar
          position="fixed"
          color="inherit"
          elevation={0}
          sx={{
            bgcolor: theme.palette.background.default,
          }}
        >
          <Header />
          <Divider />
        </AppBar>
        <Outlet />
      </Box>
    </Box>
  );
};

export default HomeLayout;
